// src/utils/notifyBridge.ts
var notifyFn = null;
var setNotifyFn = (fn) => {
  notifyFn = fn;
};
var notifyGlobalError = (message) => {
  notifyFn?.(message);
};

export {
  setNotifyFn,
  notifyGlobalError
};
